module.exports = __webpack_public_path__ + "img/img3.334b126d.svg";